<template>
  <!--srcviewscompanylistcompanyvuehtmlStart-->

  <div id="defaultId1" class="uedbd2" style="display: flex">
    <div
      :class="token && this.Saved == '' && !this.Compare ? '' : 'vague'"
      style="height: 100%"
      v-show="!Compare"
    >
      <div
        class="wrap_search_box"
        :class="$store.state.app.isMenu ? '' : 'hidemenu'"
      >
        <el-collapse class="filter_first_box" v-model="filterMenu">
          <el-collapse-item title="" name="1" class="filter_first_item">
            <template slot="title">
              <span class="left_menu_filter">
                {{ $t("Toolbar.Filter") }} ({{
                  companyScoreTypeConfirm.length
                }})
                <i class="iconfont icon-lujing fiter_ic"></i>
              </span>
              <span class="clear_all" @click.stop="clearAllTags">
                <i class="iconfont icon-qingchu"></i
                >{{ $t("ListofResults.ClearAll") }}
              </span>
            </template>

            <div class="filter_first_checkbox">
              <el-checkbox
                :indeterminate="filterIndeterminate"
                v-model="filterCheckAll"
                @change="onFilterCheckAll"
                class="checkAll"
                >{{ $t("Toolbar.ALL") }}</el-checkbox
              >
              <el-checkbox-group
                fill="#1290c9"
                v-model="companyScoreType"
                @change="(val) => onChangeParams(val)"
              >
                <el-checkbox
                  :label="ops.code"
                  v-for="(ops, index) in filterList"
                  :key="index"
                >
                  <span class="check_label">
                    <OverflowTooltip :tip="ops.name" />
                  </span>
                </el-checkbox>
              </el-checkbox-group>
              <el-button class="filter_first_btn" @click="confirmFilter">{{
                $t("ListofResults.Confirm")
              }}</el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse
          v-model="openMenu"
          v-loading="Leftloadig"
          @change="zhankai()"
          ref="collapseItem"
        >
          <el-collapse-item title="Country" name="2" v-show="isCountryShow">
            <template slot="title">
              <span>{{ $t("ListofResults.Country") }}</span>
            </template>
            <div class="cas_panel cas_loc">
              <input
                type="text"
                v-model="cascInptCountry"
                v-show="showInptCountry"
                class="cas_input"
                :placeholder="$t('ListofResults.SelectCountry')"
                @input="inptCountrySearch"
              />
              <el-cascader
                ref="Country"
                v-click-outside="clickOutSide3"
                :placeholder="$t('ListofResults.SelectCountry')"
                :key="cascaderKey"
                v-model="countryCheckList"
                @change="menuCheck('country')"
                :options="countryList"
                :props="{ multiple: true }"
                collapse-tags
                popper-class="cas_loc_box search_cas_loc_box ticket_ccCascader"
              >
                <template slot-scope="{ data }">
                  <el-tooltip
                    class="casca_lab"
                    effect="dark"
                    :disabled="data.label.length < 10"
                    :content="data.label"
                    placement="left"
                  >
                    <span class="casca_lab">
                      <span ref="sty">{{ data?.label }}</span>
                    </span>
                  </el-tooltip>
                  <span class="casca_count">{{ data.count | FilterNum }}</span>
                </template>
              </el-cascader>
            </div>
          </el-collapse-item>

          <el-collapse-item title="Industry" name="3" v-show="isIndustryShow">
            <template slot="title">
              <span>{{ $t("ListofResults.Industry") }}</span>
            </template>
            <div class="cas_panel cas_loc">
              <input
                type="text"
                v-model="cascInptIndustry"
                v-show="showInptIndustry"
                class="cas_input"
                :placeholder="$t('ListofResults.SelectIndustry')"
                @input="inptIndSearch"
              />
              <el-cascader
                ref="Industry"
                v-click-outside="clickOutSide4"
                clearable
                v-model="industryCheckList"
                :key="cascaderKey"
                :options="industryList"
                :props="optionsProps"
                @change="menuCheck('Industry')"
                :placeholder="$t('ListofResults.SelectIndustry')"
                popper-class="cas_loc_box search_cas_loc_box2 indystry"
              >
                <template slot-scope="{ data }">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="data.name"
                    popper-class="el-tooltip-postion"
                    placement="right"
                  >
                    <span class="casca_lab casca_labtwo">{{ data.name }}</span>
                  </el-tooltip>
                </template>
              </el-cascader>
            </div>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('Snapshot.CompanyType')"
            name="4"
            v-show="isCompanyTypeShow"
          >
            <template slot="title">
              <span>{{ $t("ListofResults.CompanyType") }}</span>
            </template>
            <div class="wrap_child">
              <el-checkbox-group
                v-model="companyTypeCheckList"
                @change="menuCheck('companyType')"
              >
                <el-checkbox
                  v-for="(child, i) in companyTypeList"
                  :key="i"
                  :label="child.name"
                >
                  <el-tooltip
                    :disabled="isShowTooltip"
                    class="line_1 wrap_child_name"
                    effect="dark"
                    :content="child.name"
                    placement="right"
                  >
                    <div
                      @mouseover="onMouseOver(child.name, i)"
                      class="line_1 wrap_child_name"
                    >
                      <span style="font-style: none" ref="str">{{
                        child.name
                      }}</span>
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    class="wrap_child_num line_1"
                    effect="dark"
                    :content="child.count | FilterNum"
                    placement="right"
                  >
                    <span class="wrap_child_num line_1">{{
                      child.count | FilterNum
                    }}</span>
                  </el-tooltip>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('ListofResults.CompanySize')"
            name="5"
            v-show="isCompanySizeShow"
          >
            <template slot="title">
              <span>
                {{ $t("ListofResults.CompanySize") }}
              </span>
            </template>
            <div class="wrap_child">
              <el-checkbox-group
                v-model="companySizeCheckList"
                @change="menuCheck('companySize')"
              >
                <el-checkbox
                  v-for="(child, i) in companySizeList"
                  :key="i"
                  :label="child.name"
                >
                  <div class="line_1 wrap_child_name">{{ child.name }}</div>
                  <span class="wrap_child_num line_1">{{
                    child.count | FilterNum
                  }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('ListofResults.CompanyStatus')"
            name="6"
            v-show="isCompanyStatusShow"
          >
            <template slot="title">
              <span>
                {{ $t("ListofResults.CompanyStatus") }}
              </span>
            </template>
            <div class="wrap_child">
              <el-checkbox-group
                v-model="companyStatusCheckList"
                @change="menuCheck('companyStatus')"
              >
                <el-checkbox
                  v-for="(child, i) in companyStatusList"
                  :key="i"
                  :label="child.name"
                >
                  <div class="line_1 wrap_child_name">{{ child.name }}</div>
                  <span class="wrap_child_num line_1">{{
                    child.count | FilterNum
                  }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('ListofResults.ListedCompany')"
            name="7"
            v-show="isListedCompanyShow"
          >
            <template slot="title">
              <span>
                {{ $t("ListofResults.ListedCompany") }}
              </span>
            </template>
            <div class="wrap_child">
              <el-checkbox-group
                v-model="listedCompanyCheckList"
                @change="menuCheck('listedCompany')"
              >
                <el-checkbox
                  v-for="(child, i) in listedCompanyList"
                  :key="i"
                  :label="child.name"
                >
                  <div class="line_1 wrap_child_name">{{ child.name }}</div>
                  <span class="wrap_child_num line_1">{{
                    child.count | FilterNum
                  }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('ListofResults.YearsinBusiness')"
            name="8"
            v-show="isYearsinBusinessShow"
          >
            <template slot="title">
              <span>
                {{ $t("ListofResults.YearsinBusiness") }}
              </span>
            </template>
            <div class="wrap_child">
              <el-checkbox-group
                v-model="timePeriodCheckList"
                @change="menuCheck('timePeriod')"
              >
                <el-checkbox
                  v-for="(child, i) in timePeriodList"
                  :key="i"
                  :label="child.name"
                >
                  <div class="line_1 wrap_child_name">{{ child.name }}</div>
                  <span class="wrap_child_num line_1">{{
                    child.count | FilterNum
                  }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div
      id="cc5f49"
      :class="
        $store.state.app.isMenu
          ? 'scrollbar scrollbar_right'
          : ' scrollbar scrollbar_right udb507two'
      "
      :style="{
        width: Compare ? '100%' : undefined,
        marginLeft: Compare ? '0' : undefined,
      }"
    >
      <div
        :class="
          Compare ? '' : 'right_cont_box computer_right_cont_box company_box'
        "
      >
        <div class="table-index" v-show="!Compare">
          <div class="search_rsult_txttwo line_2">
            <span>
              <!-- {{ $t("ListofResults.Foundover") }}  -->
              Found over
              <span class="foundOverNum">{{ page.total | FilterNum }}</span>
              <span v-if="!Remove">
                "
                {{
                  $store.state.app.labelCodeName == ""
                    ? this.$route.query.CompanyDetail
                      ? this.$route.query.CompanyDetail
                      : searchName
                    : $store.state.app.labelCodeName
                }}"
                <!-- {{ $t("ListofResults.results") }} -->
                results</span
              >
            </span>
            <div class="btnBox">
              <div
                v-if="Remove"
                style="display: flex; align-items: center; cursor: pointer"
                class="removeBox"
              >
                <svg
                  t="1728612191932"
                  @click="backonlonad()"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9222"
                  width="24"
                  height="24"
                >
                  <path
                    d="M879.476364 470.341818H244.829091L507.112727 209.454545a41.658182 41.658182 0 0 0-58.88-58.88L114.967273 482.676364a41.890909 41.890909 0 0 0 0 58.88l333.265454 333.032727a41.658182 41.658182 0 0 0 58.88 0 41.890909 41.890909 0 0 0 0-58.88L244.829091 553.658182h634.647273a41.658182 41.658182 0 1 0 0-83.316364z"
                    p-id="9223"
                    fill="#1296db"
                  ></path>
                </svg>
                <el-button
                  :class="
                    $store.state.app.changeList.length == 0
                      ? ' btn_export btn_exporthui'
                      : 'btn_exportred btn_export'
                  "
                  :disabled="$store.state.app.changeList.length == 0"
                  @click="CollectDelate"
                  >{{ $t("ListofResults.Remove") }}</el-button
                >
              </div>
              <el-button
                v-if="isOpenSlct && !Remove"
                :class="
                  $store.state.app.collectList.length == 0 ||
                  $store.state.app.changeList.length == 0
                    ? ' btn_export btn_exporthui'
                    : 'btn_export'
                "
                :disabled="
                  $store.state.app.collectList.length == 0 ||
                  $store.state.app.changeList.length == 0
                "
                @click="CollectCheckBook"
                >{{ $t("ListofResults.Confirm") }}</el-button
              >

              <el-button
                v-if="isOpenSlct"
                :class="
                  $store.state.app.changeList.length == 0
                    ? ' btn_export btn_exporthui'
                    : 'btn_export'
                "
                :disabled="$store.state.app.changeList.length == 0"
                @click="RescanCheckBook"
                >{{ $t("Home.RiskScan") }}</el-button
              >
            </div>
          </div>
          <div
            class="table_box company_list table_container"
            id="tableBox"
            @scroll="handleScroll($event)"
            v-loading="loading"
            ref="tableBox"
          >
            <el-table
              @header-dragend="handleDragEnd"
              class="table_height_30 table_contentHeight_40 table_padding_0"
              @selection-change="handleSelectionChange"
              ref="treeTable"
              id="tableNode"
              v-loadmore="loadMorePerson"
              :data="parentTable"
              height="100%"
              :row-class-name="getRowClass"
              :border="true"
              cell-class-name="company line_1"
              row-key="aaa_id"
              :expand-row-keys="expands"
            >
              <el-table-column
                v-if="isOpenSlct"
                type="selection"
                width="40 "
                align="center"
                class-name="blockcell"
              >
              </el-table-column>
              <el-table-column type="expand" align="center" width="1">
                <template slot-scope="scope">
                  <div
                    class="tree_table_box"
                    v-if="scope.row.branchNumber == 1"
                  >
                    <el-table
                      ref="subTreeTable"
                      :data="childTable"
                      :border="true"
                      cell-class-name="company company_list_Child line_1"
                      :key="refresh"
                      v-loading="ChiladTableloading"
                      :show-header="false"
                      empty-text="No Data"
                      @selection-change="ChildhandleSelectionChange"
                    >
                      <el-table-column
                        v-if="isOpenSlct"
                        type="selection"
                        width="40"
                        align="center"
                      >
                      </el-table-column>
                      <el-table-column
                        :label="$t('ListofResults.CompanyName')"
                        min-width="620"
                        align="left"
                        show-overflow-tooltip
                        :resizable="false"
                        class-name="company company_link company_link_tooltip_normal"
                      >
                        <template slot-scope="scope">
                          <div class="flex_center_start_box">
                            <img :src="scope.row.flag" />
                            <div
                              @click="setid(scope.row)"
                              class="tbl_company"
                              v-if="isComapanyNameEn"
                            >
                              {{
                                scope.row.company_name_en == "" ||
                                scope.row.company_name_en == undefined ||
                                scope.row.company_name_en == null
                                  ? scope.row.company_name
                                  : scope.row.company_name_en
                              }}
                            </div>
                            <div
                              v-else
                              @click="setid(scope.row)"
                              class="tbl_company"
                            >
                              {{ scope.row.company_name }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-for="(item, index) in selectedColumns"
                        :key="index"
                        :label="item.screenName"
                        :min-width="
                          item.columnName == 'province_en' ? 330 : 200
                        "
                        :prop="item.columnName"
                        show-overflow-tooltip
                        :resizable="true"
                        align="left"
                      />
                      <template v-if="retchildren" slot="empty">
                        <div
                          style="
                            padding: 1.428em;
                            text-align: left;
                            line-height: 2.857em;
                          "
                        >
                          if the search results are not as you expected, please
                          revise your search keywords and use advanced selection
                          criteria in the left panel to enhance your search
                          result. Meanwhile, you can contact our service team to
                          report errors or for assistance.
                        </div>
                      </template>

                      <template v-else slot="empty">
                        <div style="text-align: center; width: 100%">
                          No Data
                        </div>
                      </template>
                    </el-table>

                    <div class="pagination_box">
                      <Page
                        :keyword="scope.row.company_name"
                        :fontColor="'#1290C9'"
                        :total="pageChild.total"
                        :pageSize="pageChild.pageSize"
                        :currentPage="pageChild.pageNo"
                        @onPageChange="onChangePage"
                      ></Page>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('ListofResults.CompanyName')"
                min-width="620"
                prop="company_name_en"
                align="left"
                class-name="company company_link company_link_tooltip_normal"
                show-overflow-tooltip
                :resizable="true"
              >
                <!-- 114514 -->
                <template slot="header" slot-scope="scope">
                  <span
                    class="flex_center_start_box"
                    style="font-family: 'Arial Bold'"
                    >{{ $t("ListofResults.CompanyName") }}
                    <el-tooltip
                      effect="dark"
                      content="translation"
                      placement="top"
                    >
                      <svg
                        t="1745228136270"
                        @click="cangeCompanyEn"
                        style="margin-left: 10px"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="6240"
                        width="25"
                        height="25"
                      >
                        <path
                          d="M181.333333 462.741333h660.672a32 32 0 1 0 0-64H181.333333a32 32 0 0 0 0 64M388.650667 786.837333L203.946667 602.154667a32 32 0 1 0-45.248 45.248l184.682666 184.682666a32 32 0 1 0 45.248-45.248"
                          p-id="6241"
                          fill="#1290C9"
                        ></path>
                        <path
                          d="M634.709333 267.946667l184.682667 184.704a32 32 0 1 0 45.248-45.248l-184.682667-184.682667a32 32 0 1 0-45.248 45.248M842.026667 592.042667H181.333333a32 32 0 1 0 0 64h660.693334a32 32 0 0 0 0-64"
                          p-id="6242"
                          fill="#1290C9"
                        ></path>
                      </svg>
                    </el-tooltip>
                  </span>
                </template>

                <template slot-scope="scope">
                  <div
                    class="flex_center_start_box"
                    style="flex: none; width: 100%"
                  >
                    <div class="flex_center_start_box" style="flex: none">
                      <div
                        class="btn_expand"
                        :class="{ expand_icon: scope.row.isExpand }"
                        @click="onClickExpansion(scope.row)"
                      ></div>

                      <img
                        @click="gotocountry(scope.row)"
                        :src="scope.row.flag"
                      />
                    </div>

                    <div
                      @click="setid(scope.row)"
                      class="tbl_company"
                      v-if="isComapanyNameEn"
                    >
                      {{
                        scope.row.company_name_en == "" ||
                        scope.row.company_name_en == undefined ||
                        scope.row.company_name_en == null
                          ? scope.row.company_name
                          : scope.row.company_name_en
                      }}
                    </div>
                    <div v-else @click="setid(scope.row)" class="tbl_company">
                      {{ scope.row.company_name }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in selectedColumns"
                :key="index"
                :label="item.screenName"
                :min-width="item.columnName == 'province_en' ? 330 : 200"
                :prop="item.columnName"
                show-overflow-tooltip
                :resizable="true"
                align="left"
              />

              <template slot="empty">
                <div style="text-align: left" v-if="this.Saved == ''">
                  <noDate />
                </div>
                <div class="flex_center margin-top30" v-else>No Data</div>
              </template>
            </el-table>
          </div>
        </div>
        <div class="CompanyCompany" v-show="Compare">
          <compareCompanys
            :compareList="compareList"
            @CompareShowfalse="CompareShow($event)"
          ></compareCompanys>
        </div>
      </div>
    </div>
    <Suo
      :suoClose="Update"
      @closeCloseDialog="clossuoDialog($event)"
      @closeCloseDialog1="clossuoDialog1($event)"
    ></Suo>
    <Deepassment
      :showReport="showReportIndex"
      @closeReportDialog="closeDialog3($event)"
    ></Deepassment>
    <Reporterror
      :showReport="ReportError"
      :companynameen="CompanyName"
      @closeReportDialog="closeDialog($event)"
      :powerStatus="powerToReportErrorStatus"
    ></Reporterror>

    <!-- 提示选择多少条 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogVisible2"
      :before-close="
        () => {
          riskScanDialogVisible2 = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_550"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_search_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("RiskScan.Scanning") }}
        </div>
        <div class="risk_text">
          {{ $t("RiskScan.Youhaveselectedatotalof") }}
          <span class="num">{{ riskScanDialogLength }}</span>
          {{ $t("RiskScan.Tostartriskscanning") }}
        </div>
      </div>

      <div slot="footer" class="dialog_footer">
        <!-- <el-button
          @click="riskScanDialogVisible2 = false"
          class="risk_cancel_btn"
          type="cancel"
          >{{ $t("RiskScan.Cancel") }}</el-button
        > -->
        <el-button
          @click="confirmSanCheck"
          class="risk_primary_btn"
          type="primary"
          >{{ $t("RiskScan.Confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { searchCompany } from "@/api/searchApi.js";
import { addItems, showItems, removeItems } from "@/api/userApi";
import Reporterror from "./reportError.vue";
import Suo from "./UpdateDialog.vue";
import compareCompanys from "./compareCompanys";
import noDate from "../../../components/noDate/index.vue";
import Deepassment from "../../../components/deepassment/index.vue";
import { getoptions } from "@/api/companyApi";
import Page from "@/views/newLayout/page.vue";
import bus from "../../../components/bus.js";
export default {
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  mixins: [mixins1],
  components: {
    Suo,
    Reporterror,
    noDate,
    compareCompanys,
    Deepassment,
    Page,
  },
  name: "",
  props: {},
  watch: {
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
        } else {
          this.openMenu = [];
          this.setToolsfalse();
        }
      },
      immediate: true,
    },
    //  Label
    "$store.state.app.labelCode": {
      handler(newVal, oldVal) {
        this.labelCode = newVal;
        this.page.pageNo = 1;
        this.parentTable = [];
        this.searchCompanyByName();
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    // columns
    "$store.state.app.ColumnsArr": {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.selectedColumns = newVal;
        } else {
          this.selectedColumns = [];
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Clearallflase: {
      handler(newVal, oldVal) {
        if (oldVal != undefined) {
          this.clearAllTags();
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        if (newVal == false) {
          this.handleSelectionChange([]);
          this.ChildhandleSelectionChange([]);
          if (this.$refs.treeTable) {
            this.$refs.treeTable.clearSelection();
          }
          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
        }
        this.refresh++;
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Sort: {
      handler(newVal, oldVal) {
        this.Sort = newVal;
        if (newVal.length > 0) {
          this.page.pageNo = 1;
          this.parentTable = [];
          this.searchCompanyByName();
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Saved: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.parentTable = [];
          this.pageNo = 1;
          this.Saved = newVal;
          this.getCollection();
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Update: {
      handler(newVal, oldVal) {
        this.Update = newVal;
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Compare: {
      handler(newVal, oldVal) {
        this.Compare = newVal;
        if (this.Compare) {
          this.setToolsfalse();
        } else {
          this.handleSelectionChange([]);
          this.refresh++;
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Export: {
      handler(newVal, oldVal) {
        this.Export = newVal;
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    ReportError: {
      handler(newVal, oldVal) {
        this.ReportError = newVal;
        this.powerToReportErrorStatus = true;
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },

    countryList(val) {
      this.cascaderKey++;
    },
    industryList(val) {
      this.cascaderKey++;
    },
  },
  updated() {
    this.$nextTick(function () {
      this.formatCC();
    });

    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  beforeDestroy() {
    this.$off("closeReportDialog");
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    this.getPower();
  },
  mounted() {
    this.setThemeColor();
    this.setTools();
  },
  computed: {
    filteredColumns() {
      return this.columns.filter((column) => column.visible);
    },
  },

  data() {
    return {
      loadingVisible: false,
      loadingNum: 0,
      innerPercent: 0,
      startTime: 0,
      totalCount: 0, // 传入数量
      maxCount: 200,
      maxTime: 30000, // 30s
      isComapanyNameEn: true,
      compareList: [],
      compareListParent: [],
      compareListChildreant: [],
      Remove: false,
      isFadedIn: true,
      loading: true,
      isOpenSlct: false,
      Clearallflase: false,
      showReportIndex: false,
      Compare: false,
      Export: false,
      Download: false,
      Update: false,
      Saved: "",
      Sort: [],
      labelCode: [],
      ReportError: false,
      CompanyName: "",
      powerToReportErrorStatus: false,
      retchildren: false,
      riskScanDialogVisible2: false,
      riskScanDialogLength: 0,
      columns: [
        "company_name",
        "province_en",
        "city_en",
        "district_en",
        "isic_code",
        "incorporation_year",
        "company_type_code",
        "scale_code",
        "status",
      ],
      pageChild: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      page: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      pageNo: 1,
      refresh: 0,
      pageSize: 100,
      ChiladTableloading: false,
      powerResult: { list: [] },
      token: localStorage.getItem("token"),
      optionsProps: {
        label: "name", //名称展示
        value: "value", //值展示
        expandTrigger: "click", //次级菜单的展开方式
      },
      parentTable: [],
      expands: [],
      cascInptCountry: "",
      showInptCountry: true,
      cascInptIndustry: "",
      showInptIndustry: true,
      childTable: [],
      showColumnSelector: false,
      selectedColumns: [],

      checkedCompanyList: [],
      companyList: [],
      companyTblList: [],
      branchflag: "",
      openMenu: ["2", "3", "4", "5", "6", "7", "8"],
      countryPreList: [],
      countryList: [],
      countryCheckList: [],
      countryTag: [],
      countryCheck: "",

      industryPreList: [],
      industryList: [],
      industryCheckList: [],
      industryTag: [],
      industryCheck: "",

      companyTypeList: [],
      companyTypeList1: [],
      companyTypeCheckList: [],
      companyTypeTag: [],
      companyTypeCheck: "",

      companySizeList: [],
      companySizeCheckList: [],
      companySizeTag: [],
      companySizeCheck: "",

      companyStatusList: [],
      companyStatusCheckList: [],
      companyStatusTag: [],
      companyStatusCheck: "",

      listedCompanyList: [],
      listedCompanyCheckList: [],
      listedCompanyTag: [],
      listedCompanyCheck: "",

      timePeriodList: [],
      timePeriodCheckList: [],
      timeTag: [],
      timePeriodCheck: "",
      province: [],
      city: [],
      keywords: "",
      cascaderKey: 0,
      Leftloadig: false,
      searchName: "",
      isShowTooltip: false,
      checkList: [],
      labelCodeName: "",

      aaaidList: [],
      companyScoreType: [1, 2, 3, 4, 5, 6, 7],
      companyScoreTypeConfirm: [1, 2, 3, 4, 5, 6, 7],
      filterList: [
        {
          code: 1,
          name: "Country",
        },
        {
          code: 2,
          name: "Industry",
        },
        {
          code: 3,
          name: "Comapny Type",
        },
        {
          code: 4,
          name: "Comapny Size",
        },
        {
          code: 5,
          name: "Comapny Status",
        },
        {
          code: 6,
          name: "Listed Comapny",
        },
        {
          code: 7,
          name: "Years in Business",
        },
      ],
      filterIndeterminate: false,
      filterCheckAll: true,
      filterMenu: [1],
      isCountryShow: true,
      isIndustryShow: true,
      isCompanyTypeShow: true,
      isCompanySizeShow: true,
      isCompanyStatusShow: true,
      isListedCompanyShow: true,
      isYearsinBusinessShow: true,
    };
  },

  methods: {
    handleDragEnd(newWidth, oldWidth, column, event) {
      if (newWidth < 175) {
        newWidth = column.label.length * 20;
        column.width = column.label.length * 20;
        column.minWidth = column.label.length * 20;
        column.realWidth = column.label.length * 20;
      }
      if (
        column.label == this.$t("ListofResults.CompanyName") &&
        newWidth < 620
      ) {
        newWidth = 620;
        column.width = 620;
        column.minWidth = 620;
        column.realWidth = 620;
        this.subTableWidth = 620;
      }
      const collabel = column.label;
      const subTable = this.$refs.subTreeTable;
      const targetColumn = subTable.columns.find(
        (column) => column.label === collabel,
      );
      if (targetColumn.label == this.$t("ListofResults.CompanyName")) {
        targetColumn.width = newWidth - 10;
      } else {
        targetColumn.width = newWidth;
      }
      this.$nextTick(() => {
        this.$refs.treeTable.doLayout(); // 触发布局重绘
        this.$refs.subTreeTable.doLayout();
      });
    },
    // 查询不多数据报告错误
    closeDialog3(value) {
      this.showReportIndex = value;
    },
    // 翻译
    cangeCompanyEn() {
      this.isComapanyNameEn = !this.isComapanyNameEn;
    },
    clickOutSide3() {
      if (this.$refs.Country) {
        this.$refs.Country.dropDownVisible = false;
      }
    },
    clickOutSide4() {
      if (this.$refs.Industry) {
        this.$refs.Industry.dropDownVisible = false;
      }
    },
    loadMorePerson() {
      // 加载更多数据的逻辑
      let el = document.getElementById("tableNode");
      if (this.Saved) {
        this.pageNo = this.pageNo + 1;
        if (this.page.total > this.parentTable.length) {
          this.getCollection();
        }
      } else {
        this.page.pageNo = this.page.pageNo + 1;
        if (this.page.total > this.parentTable.length) {
          this.searchCompanyByName();
        }
      }
    },
    backonlonad() {
      this.$router.go(0);
    },
    // 触底刷新
    handleScroll(e) {
      const scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
      const windowHeitht = e.target.clientHeight; //能看到的页面的高度
      const scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      const total = scrollTop + windowHeitht + 1;

      if (total >= scrollHeight) {
        if (this.Saved) {
          this.pageNo = this.pageNo + 1;
          this.getCollection();
        } else {
          this.page.pageNo = this.page.pageNo + 1;
          if (this.page.total > this.parentTable.length) {
          }
        }

        //加载操作
      }
    },
    //搜索公司
    async searchCompanyByName(total) {
      this.loading = true;
      this.searchName = this.$route.query.CompanyDetail
        ? ""
        : this.$route.query.searchname
        ? this.$route.query.searchname
        : "";
      this.searchCode = this.$route.query.companyCountry
        ? this.$route.query.companyCountry
        : "";
      this.keywords = this.$route.query.keword;
      let arr = [];
      if (this.labelCode) {
        arr = this.labelCode.map((item) => item.aaaId);
      }

      let labelCodeArr = arr
        .map((item) => `${encodeURIComponent(item)}`)
        .join(",");

      let params = {
        aaaids: this.labelCode.length == 0 ? "" : labelCodeArr,
        company_country: this.countryCheck
          ? this.countryCheck
          : this.$route.query.companyCountry,
        company_name: this.labelCode.length == 0 ? this.searchName : "",
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        province_en: this.province,
        companyLabelV2: this.$route.query.CompanyDetail,
        city_en: this.city,
        isic_code: this.industryCheck,
        company_class_code: this.companyTypeCheck,
        searchType: this.keywords,
        scale_code: this.companySizeCheck,
        reg_status: this.companyStatusCheck,
        listing_status_code: this.listedCompanyCheck,
        years: this.timePeriodCheck,
        sortType: this.Sort[0],
        sortColumn: this.Sort[1],
      };
      let res = await searchCompany(params);

      let parentTable = [];
      if (res.code == 200) {
        this.page.total = res.data.total;
        let list = (parentTable = res.data.rows);

        //查找本地图片
        list = list.map((item, index) => {
          let countryImg = this.getCountryImgUrl(item.company_country);
          if (countryImg) {
            let flag = require("../../../../static" + countryImg);

            parentTable[index].flag = flag;
            this.refresh++;
          }
        });
        this.parentTable.push(...parentTable);
        this.loading = false;

        if (total) {
          var tableBox = document.getElementById("tableBox"); // 获取需要滚动的节点
          this.$nextTick(() => {
            tableBox.scrollTop = total - 10;
          });
        }
      } else {
        if (res.code == "1002") {
          this.loading = false;
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        } else {
          this.parentTable = [];
          this.loading = false;
        }
      }
    },
    // 获取收藏
    getCollection() {
      showItems({
        collectionId: this.Saved,
        page: this.pageNo,
        size: 100,
      }).then((res) => {
        if (res.code == 200) {
          this.Remove = true;
          this.ChildhandleSelectionChange([]);
          this.cheeckbooksUpdate([]);
          this.$store.dispatch("app/setchangeList", []);
          this.$store.dispatch("app/setTools", {
            name: "collect",
            key: "isActive",
            value: false,
          });

          this.$store.dispatch("app/setTools", {
            name: "sort",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "filter",
            key: "isActive",
            value: false,
          });

          this.loading = false;
          this.page.total = res.data.total;
          let parentTable = [];
          let list = (parentTable = res.data.rows);

          //查找本地图片
          list = list.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.company_country);
            if (countryImg) {
              let flag = require("../../../../static" + countryImg);
              parentTable[index].flag = flag;
              this.refresh++;
            }
          });
          this.parentTable.push(...parentTable);
        } else {
          this.loading = false;
          this.parentTable = [];
          if (res.ret == "1002") {
            this.ret = true;
          } else {
            this.ret = false;
          }
        }
      });
    },
    //扫描确认
    confirmSanCheck() {
      this.riskScanDialogVisible2 = false;
      this.aaaidList = [];
      this.$store.state.app.changeList.map((item) => {
        this.aaaidList.push(item.aaa_id);
      });
      //跳转
      let routeData = this.$router.resolve({
        path: "/riskScanning/index",
        query: { aaaids: this.aaaidList.join("@@") },
      });
      window.open(routeData.href, "_blank");
    },
    //Rescan
    RescanCheckBook() {
      this.riskScanDialogVisible2 = true;
      this.riskScanDialogLength = this.$store.state.app.changeList.length;
    },
    // 收藏
    CollectCheckBook() {
      this.checkList = this.$store.state.app.collectList;
      let collect = [];
      this.$store.state.app.changeList.map((item) => {
        collect.push(item.aaa_id);
      });

      this.checkList.forEach((item) => {
        addItems({
          collectionId: item,
          items: collect,
        }).then((Res) => {
          if (Res.code == 200) {
            this.$message({
              message: Res.msg,
              center: true,
              type: "success",
            });
          } else {
            this.$message({
              message: Res.msg,
              center: true,
              type: "error",
            });
          }
        });
      });
    },
    // 删除收藏
    CollectDelate() {
      let ids = [];
      this.$store.state.app.changeList.map((item) => {
        ids.push(item.collectId);
      });
      removeItems({ ids }).then((res) => {
        if (res.code == 200) {
          this.pageNo = 1;
          this.parentTable = [];
          this.getCollection();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    // 公司对比返回
    CompareShow(val) {
      this.Compare = false;
      this.setTools();
    },

    //关闭report弹窗
    closeDialog(value) {
      this.ReportError = value;
    },
    // 关闭锁谈框
    clossuoDialog(value) {
      this.Update = value;
    },

    clossuoDialog1(value) {},
    // 清楚选中

    onChangePage(pagParm) {
      this.searchParams.currentPage = pagParm.page;
      this.searchParams.pageSize = pagParm.pageSize;
      this.getPageList();
    },

    // 点击跳转
    setid(row) {
      if (this.token) {
        sessionStorage.setItem("company", JSON.stringify(row));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
          ?.countryList;
        let SACode1 = "";
        newscountry.map((item) => {
          if (item.countryCode == row.company_country) {
            SACode1 = item.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          path:
            "/index/company/details/" +
            row.aaa_id +
            "/background/snapshot?id3a=" +
            row.aaa_id +
            "&companyCountry=" +
            row.company_country +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            row.company_name_en +
            "&keword=" +
            this.$route.query.keword,
        });

        window.open(routeData.href, "_blank");
      }else{
        bus.$emit("handleShowLogin", true);
      }
    },
    // insertMetho
    getPower() {
      this.getConditions();
    },
    //
    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
    },
    // 字选项多选
    ChildhandleSelectionChange(val) {
      this.compareListChildreant = val;

      this.cheeckbooksUpdate(val);
    },
    // 多选
    handleSelectionChange(val) {
      this.compareListParent = val;
      this.cheeckbooksUpdate(val);
    },
    //多选选择国家判断状态
    cheeckbooksUpdate(val) {
      this.compareList = [
        ...this.compareListParent,
        ...this.compareListChildreant,
      ];
      if (val.length == 1) {
        this.CompanyName = val[0].company_name_en;
      }
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 101,
      });
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: this.compareList.length > 0 && this.Saved == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: this.compareList.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      // 添加 选中公司
      this.$store.dispatch("app/setchangeList", this.compareList);
      //添加 选中公司 风险扫描
      sessionStorage.setItem("riskScanList", JSON.stringify(this.compareList));
    },

    default() {}, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#1290C9");
      this.$store.dispatch("app/setSearchType", "company");
    }, //
    // 工具栏高亮控制
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: true && this.token,
      });

      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // openDetails
    openDetails() {
      return;

      this.$router.push({
        path: "company/details/111",
      });
    }, // slct_rows
    slct_rows(value) {
      this.rowsSlct = value;
      this.$emit("setRowsSlct", this.rowsSlct);
    }, // selectItem
    selectItem(key, item) {
      if (key == "companyName") {
        this.$router.push({
          path: "/index/company/details/1111/background/snapshot",
        });
      }
    }, // openContentTable
    async openContentTable(id) {
      await this.$nextTick();
    },
    checkedAllCompany(val) {
      this.checkedCompanyList = val ? this.companyList : [];
    },
    //展开当前关闭其他展开表格
    onClickExpansion(row) {
      if (this.expands.indexOf(row.aaa_id) < 0) {
        this.expands = [];
        this.expands.push(row.aaa_id);
        this.branchflag = row.aaa_id;
        if (row.branchNumber == 1) {
          this.pageChild.pageNo = 1;
          this.searchChildCompanyByName();
        }
      } else {
        this.expands = [];
      }
    },
    // 判断表格是否有子项，无子项不显示展开按钮
    getRowClass(row, rowIndex) {
      // children 是你子项的数组 key
      if (row.row.branchNumber == 0) {
        return "row-expand-cover";
      }
    },
    zhankai() {
      let hasPower = true;
      if (!hasPower) {
        this.openMenu = [];
      }
      this.$refs.Country.dropDownVisible = false;
      this.$refs.Industry.dropDownVisible = false;
    },
    onChangePage(pagParm) {
      this.pageChild.pageNo = pagParm.page;
      this.pageChild.pageSize = pagParm.pageSize;
      this.searchChildCompanyByName();
    },

    //搜索子表
    async searchChildCompanyByName() {
      this.ChiladTableloading = true;
      const params = {
        branchflag: this.branchflag,
        page: this.pageChild.pageNo,
        pageSize: this.pageChild.pageSize,
      };
      let res = await searchCompany(params);
      if (res.code == 200) {
        this.ChiladTableloading = false;
        this.pageChild.total = res.data.total;
        let list = (this.childTable = res.data.rows);

        list = list.map((item, index) => {
          let countryImg = this.getCountryImgUrl(item.company_country);
          if (countryImg) {
            let flag = require("../../../../static" + countryImg);
            this.childTable[index].flag = flag;
          }
        });
      } else {
        this.ChiladTableloading = false;
        this.childTable = [];
        this.pageChild.total = 0;
        if (res.code == "1002") {
          this.retchildren = true;
        } else {
          this.retchildren = false;
        }
      }
    },
    // 国家筛选新增添加删除
    formatCC() {
      let htmladd = document.createElement("bottom");
      let htmladd2 = document.createElement("bottom2");

      htmladd.innerHTML = "Confirm";
      htmladd.className = "htmladd";
      htmladd2.innerHTML = "Delete";
      htmladd2.className = "htmladd2";
      htmladd.style.cssText =
        "cursor: pointer;position: absolute;bottom: -35px;height: 35px;line-height:35px;width:50%;background:#fff;text-align: center;color:#606266;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);";
      htmladd2.style.cssText =
        "cursor: pointer;position: absolute;bottom: -35px;right: 0;height: 35px;line-height:35px;width:50%;background:#fff;text-align: center;color:#606266;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);";
      let that = this;
      var el_l = document.querySelectorAll(
        ".el-popper.el-cascader__dropdown.ticket_ccCascader",
      );
      if (el_l.length > 0 && el_l.length == 1) {
        var el = el_l[0];

        if (!el.querySelector(".htmladd")) {
          el.appendChild(htmladd);
          var bo = el.querySelectorAll(".htmladd")[0];
          bo.onclick = function () {
            that.$refs.Country.dropDownVisible = false;
            that.getConditions();
            that.page.pageNo = 1;
            that.parentTable = [];
            that.searchCompanyByName();
          };
        }

        var el1 = el_l[0];
        if (!el1.querySelector(".htmladd2")) {
          el1.appendChild(htmladd2);
          var bo1 = el1.querySelectorAll(".htmladd2")[0];
          bo1.onclick = function () {
            that.countryCheckList = [];
            that.countryTag = [];
            that.province = "";
            that.arrProvTag = [];
            that.countryCheck = "";
            that.$refs.Country.dropDownVisible = false;
            that.showInptCountry = true;
            that.parentTable = [];
            that.page.pageNo = 1;
            that.getConditions();
            that.searchCompanyByName();
          };
        }
      }
    },

    // Company type 超出省略 显示
    onMouseOver(str, i) {
      const tag = this.$refs.str[i];
      const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth;
    },
    //菜单checkbox选择
    menuCheck(val) {
      if (val === "country") {
        const checkedNodes = this.$refs.Country.getCheckedNodes();
        const allNodes = this.$refs.Country.getCheckedNodes(true);
        const isAllSelected = checkedNodes.length === allNodes.length;
        let arrCountry = [];
        let arrProv = [];
        let arrCountryTag = [];
        let arrCountrycheck = [];
        this.countryCheckList.forEach((item) => {
          if (isAllSelected) {
            if (item.length == 1) {
              if (!arrCountry.includes(item[0])) {
                this.countryList.forEach((ite) => {
                  if (ite.value == item[0]) {
                    arrCountryTag.push(ite.label); //展示
                  }
                });

                arrCountry.push(item[0]); //传值
              }
            } else {
              arrProv.push(item[1]);
            }
          } else {
            if (!arrCountry.includes(item[0])) {
              this.countryList.forEach((ite) => {
                if (ite.value == item[0]) {
                  arrCountryTag.push(ite.label); //展示
                }
              });

              arrCountry.push(item[0]); //传值
            }
          }

          if (!arrCountrycheck.includes(item[0])) {
            arrCountrycheck.push(item[0]); //传值
          }
        });

        this.countryTag = arrCountryTag;
        this.arrProvTag = arrProv;

        this.countryCheck = arrCountrycheck.join("@@");
        this.province = arrProv.join("@@");

        //显示隐藏国家级联选择器的输入框
        if (this.countryTag.length > 0 || this.arrProvTag.length > 0) {
          this.showInptCountry = false;
          this.cascInptCountry = "";
        } else {
          this.showInptCountry = true;
        }
      } else {
        if (val === "Industry") {
          let arr = [];
          this.industryCheckList.forEach((item) => {
            this.industryList.forEach((it) => {
              if (it.value == item) {
                arr.push(it);
              }
            });
          });
          this.industryTag = arr;
          this.industryCheck = this.industryCheckList[1];
          //显示隐藏行业级联选择器的输入框
          if (this.industryCheckList.length > 0) {
            this.showInptIndustry = false;
            this.cascInptIndustry = "";
          } else {
            this.showInptIndustry = true;
          }
        }
        let arr = [];

        this.companyTypeCheckList.forEach((item) => {
          this.companyTypeList.forEach((it) => {
            if (it.name == item) {
              arr.push(it);
            }
          });
        });
        this.companyTypeTag = arr;
        let arrlist = [];
        arr.map((item) => {
          arrlist.push(item.value);
        });

        this.companyTypeCheck = arrlist.join("@@");
        let arr1 = [];
        this.companySizeCheckList.forEach((item) => {
          this.companySizeList.forEach((it) => {
            if (it.name == item) {
              arr1.push(it);
            }
          });
        });
        let arrlist1 = [];
        arr1.map((item) => {
          arrlist1.push(item.value);
        });
        this.companySizeTag = arr1;
        this.companySizeCheck = arrlist1.join("@@");
        let arr2 = [];
        this.listedCompanyCheckList.forEach((item) => {
          this.listedCompanyList.forEach((it) => {
            if (it.name == item) {
              arr2.push(it);
            }
          });
        });
        let arrlist2 = [];
        arr2.map((item) => {
          arrlist2.push(item.value);
        });
        this.listedCompanyTag = arr2;
        this.listedCompanyCheck = arrlist2.join("@@");
        let arr3 = [];
        this.companyStatusCheckList.forEach((item) => {
          this.companyStatusList.forEach((it) => {
            if (it.name == item) {
              arr3.push(it);
            }
          });
        });
        let arrlist3 = [];
        arr3.map((item) => {
          arrlist3.push(item.value);
        });
        this.companyStatusTag = arr3;
        this.companyStatusCheck = arrlist3.join("@@");
        let arr4 = [];
        this.timePeriodCheckList.forEach((item) => {
          this.timePeriodList.forEach((it) => {
            if (it.name == item) {
              arr4.push(it);
            }
          });
        });
        let arrlist4 = [];
        arr4.map((item) => {
          arrlist4.push(item.value);
        });
        this.timeTag = arr4;
        this.timePeriodCheck = arrlist4.join("@@");
        this.parentTable = [];
        this.page.pageNo = 1;
        this.getConditions();
        this.searchCompanyByName(0);
      }

      this.$store.dispatch("app/setcollectList", []);
      this.$store.dispatch("app/setchangeList", this.compareList);
      this.handleSelectionChange([]);
      this.ChildhandleSelectionChange([]);
    },
    //获取左边菜单
    async getConditions() {
      this.Leftloadig = true;
      let arr = [];
      if (this.labelCode) {
        arr = this.labelCode.map((item) => item.aaaId);
      }

      let labelCodeArr = arr
        .map((item) => `${encodeURIComponent(item)}`)
        .join(",");

      this.searchName = this.$route.query.CompanyDetail
        ? ""
        : this.$route.query.searchname;
      const companyCountry = this.countryCheck
        ? this.countryCheck
        : this.$route.query.companyCountry;
      this.keywords = this.$route.query.keword;
      const params = {
        aaaids: this.labelCode.length == 0 ? "" : labelCodeArr,
        company_country: companyCountry,
        company_name: this.labelCode == "" ? this.searchName : "",
        province_en: this.province,
        companyLabelV2: this.$route.query.CompanyDetail,
        city_en: this.city,
        industry_en: this.industryCheck,
        company_class_code: this.companyTypeCheck,
        searchType: this.keywords,
        scale_code: this.companySizeCheck,
        reg_status: this.companyStatusCheck,
        listing_status_code: this.listedCompanyCheck,
        years: this.timePeriodCheck,
      };
      await getoptions(params).then((res) => {
        if (res && res.code) {
          this.Leftloadig = false;
          this.countryList = res.data.geographicalLocation;
          this.industryList = res.data.industry;
          this.industryPreList = res.data.industry;

          this.companyTypeList = res.data.companyTypeList;

          this.companySizeList = res.data.companySizeList;
          this.companyStatusList = res.data.regStatus;
          this.listedCompanyList = res.data.listingStatusList;
          this.timePeriodList = res.data.yearsOfEstablishment;

          let list = this.countryList;
          if (list.length > 0) {
            list.map((item, index) => {
              item.label = item.companyCountry.name;
              item.value = item.companyCountry.value;
              item.count = item.companyCountry.count;
              if (item.companyProvince) {
                item.children = item.companyProvince;
                item.children.map((it) => {
                  it.label = it.name;
                });
              }
            });
          }
          this.countryPreList = list;
        } else {
          this.Leftloadig = false;
        }
      });
    },
    //国家级联搜索不区分大小写
    inptCountrySearch() {
      this.$nextTick(() => {
        this.$refs.Country.dropDownVisible = true;
      });
      let queryString = this.cascInptCountry;
      var countryList = this.countryPreList;
      var results = queryString
        ? countryList.filter(this.createFilter(queryString))
        : countryList;
      this.countryList = results;
    },
    // 过滤数据
    createFilter(queryString) {
      return (countryList) => {
        return (
          countryList.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    //行业级联搜索不区分大小写
    inptIndSearch() {
      this.$nextTick(() => {
        this.$refs.Industry.dropDownVisible = true;
      });
      let queryString = this.cascInptIndustry;
      var industryList = this.industryPreList;

      var results = queryString
        ? industryList.filter(this.createFilterInd(queryString))
        : industryList;
      this.industryList = results;
    },
    createFilterInd(queryString) {
      return (industryList) => {
        return (
          industryList.name.toLowerCase().indexOf(queryString.toLowerCase()) >
          -1
        );
      };
    },
    onChangeParams(val) {
      this.updateFilterCheckAllStatus();
    },
    updateFilterCheckAllStatus() {
      const totalOptions = this.filterList.length;
      const checkedCount = this.companyScoreType.length;

      this.filterCheckAll = checkedCount === totalOptions;
      this.filterIndeterminate =
        checkedCount > 0 && checkedCount < totalOptions;
    },
    onFilterCheckAll(val) {
      this.companyScoreType = val
        ? this.filterList.map((item) => item.code)
        : [];
      this.filterIndeterminate = false;
    },
    confirmFilter() {
      this.filterMenu = [];
      if (this.companyScoreType.indexOf(1) == -1) {
        this.countryCheckList = [];
        this.isCountryShow = false;
        this.countryCheck = "";
      } else {
        this.isCountryShow = true;
      }
      if (this.companyScoreType.indexOf(2) == -1) {
        this.industryCheckList = [];
        this.isIndustryShow = false;
        this.industryCheck = "";
      } else {
        this.isIndustryShow = true;
      }
      if (this.companyScoreType.indexOf(3) == -1) {
        this.companyTypeCheckList = [];
        this.isCompanyTypeShow = false;
        this.companyTypeCheck = "";
      } else {
        this.isCompanyTypeShow = true;
      }
      if (this.companyScoreType.indexOf(4) == -1) {
        this.companySizeCheckList = [];
        this.isCompanySizeShow = false;
        this.companySizeCheck = "";
      } else {
        this.isCompanySizeShow = true;
      }
      if (this.companyScoreType.indexOf(5) == -1) {
        this.companyStatusCheckList = [];
        this.isCompanyStatusShow = false;
        this.companyStatusCheck = "";
      } else {
        this.isCompanyStatusShow = true;
      }
      if (this.companyScoreType.indexOf(6) == -1) {
        this.listedCompanyCheckList = [];
        this.isListedCompanyShow = false;
        this.listedCompanyCheck = "";
      } else {
        this.isListedCompanyShow = true;
      }
      if (this.companyScoreType.indexOf(7) == -1) {
        this.timePeriodCheckList = [];
        this.isYearsinBusinessShow = false;
        this.timePeriodCheck = "";
      } else {
        this.isYearsinBusinessShow = true;
      }
      this.page.pageNo = 1;
      this.parentTable = [];
      this.companyScoreTypeConfirm = this.companyScoreType;
      this.updateFilterCheckAllStatus();
      this.getConditions();
      this.searchCompanyByName();
    },
    //清除所有标签
    clearAllTags() {
      this.countryCheckList = [];
      this.industryCheckList = [];
      this.companyTypeCheckList = [];
      this.companySizeCheckList = [];
      this.companyStatusCheckList = [];
      this.listedCompanyCheckList = [];
      this.timePeriodCheckList = [];
      this.page.pageNo = 1;
      this.industryCheck = "";
      this.companyTypeCheck = "";
      this.companySizeCheck = "";
      this.companyStatusCheck = "";
      this.listedCompanyCheck = "";
      this.timePeriodCheck = "";
      this.showInptCountry = true;
      this.province = "";
      this.company_country = "";
      this.countryCheck = "";
      this.parentTable = [];
      this.companyScoreType = this.filterList.map((item) => item.code);
      this.companyScoreTypeConfirm = this.companyScoreType;
      this.filterCheckAll = true;
      this.filterIndeterminate = false;
      this.isCountryShow = true;
      this.isIndustryShow = true;
      this.isCompanyTypeShow = true;
      this.isCompanySizeShow = true;
      this.isCompanyStatusShow = true;
      this.isListedCompanyShow = true;
      this.isYearsinBusinessShow = true;
      this.getConditions();
      this.searchCompanyByName();
    },
    // srcviewscompanylistcompanyvueMethodEnd
  },
};
</script>
<style scoped>
.dialog_footer .el-button:nth-child(2) {
  padding: 0;
  height: 60px;
  margin-left: 30px;
}

.dialog_footer .el-button:nth-child(1) {
  padding: 0;
  height: 60px;
  margin-left: 0px;
}

.uedbd2 {
  height: 100%;
}

.udb507 {
  width: calc(100% - 300px);
  display: flex;
  height: 100%;
  box-sizing: border-box;
  padding: 0.7142857142857143em;
  flex-direction: column;
  padding-left: 0em;
  margin-left: 0.7142857142857143em;
  overflow: hidden;
}

.udb507two {
  width: 100% !important;
}

.u1QPawD {
  display: none;
}

.ufe717 {
  width: 12.214285714285714em;
  font-size: 1em;
  background-color: rgb(255, 255, 255);
}

.ukQ5lVZ {
  margin-left: 0.5em;
}

.u82ef5 {
  display: flex;
  padding-right: 0.5em;
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-bottom: 0.5em;
}

.u0a5ae {
  flex: auto;
  margin-left: 0.5em;
}

.u4bf20 {
  position: relative;
}

.u04a90 {
  display: flex;
  align-items: flex-start;
  height: 0;
  box-sizing: inherit;
  flex: auto;
  overflow-y: auto;
  margin-top: 0.5em;
}

.u1ec6b2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: rgb(240, 240, 240);
}

.uff2cd {
  margin-left: 3.5714285714285716em;
}

.u5t26i8 .active {
  display: block;
}

.u5t26i8 path {
  display: none;
}

.u82ef5:hover .u0a5ae {
  color: rgb(33, 104, 235);
}

.u82ef5:hover .u5a792 {
  display: block;
}

.table_box /deep/ .el-table thead .company_link > .cell {
  padding-left: 30px !important;
}
.table_box /deep/ .el-table thead th:not(.blockcell) .cell {
  border-right: 3px solid #e1e1e1 !important;
  min-height: 25px;
}
.table_box /deep/ .el-table thead .el-table-column--selection .cell {
  border-right: none !important;
  padding-right: 0 !important;
}

.table_box /deep/ th.el-table__cell > .cell {
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  font-family: "Arial Bold";
  font-size: 18px !important;
  color: #1a2332;
  line-height: 24px;
  font-style: normal;
}
.table_box /deep/ .table_check_row.el-table__cell > .cell {
  padding-left: 2px;
  padding-right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table_box /deep/ th.el-table__cell {
  height: 50px;
  padding: 0 !important;
  box-sizing: border-box;
}
.table_box /deep/ th.el-table-column--selection .cell {
  padding: 0 !important;
}
.table_box /deep/ td.el-table__cell {
  height: 60px;
  padding: 0 !important;
  box-sizing: border-box;
}
.table_box /deep/ td.el-table-column--selection .cell {
  padding-left: 4px !important;
}
.table_box /deep/ td.blockcell > .cell {
  white-space: unset;
  overflow: hidden;
  text-overflow: unset;
}
.table_box /deep/ td.el-table__cell:not(.blockcell) > .cell {
  font-weight: 400;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tree_table_box {
  padding: 10px;
}

.tree_table_box /deep/.el-table .company_link .cell {
  padding-left: 20px !important;
}
.tbl_company {
  padding-left: 10px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn_expand {
  width: 16px;
  height: 16px;
  line-height: 16px;
  min-width: 16px;
  margin-left: 0;
  text-align: center;
  background-size: 10px 6px;
  float: left;
  margin-top: 0;
  margin-right: 4px;
  cursor: pointer;
}

.wrap_search_box {
  height: 100%;
}
.wrap_search_box .el-collapse-item.is-active {
  border-bottom: 0;
}

.cas_loc {
  margin-bottom: 0;
}
.cas_loc .el-input__inner {
  height: 36px !important;
}

.cas_panel .cas_input {
  position: absolute;
  z-index: 1;
  height: 34px;
  left: 8px;
  top: 1px;
  font-size: 16px;
  background-color: #fff;
  border: none;
  width: calc(100% - 40px);
}

.wrap_child {
  width: 100%;
  overflow-y: auto;
}
.wrap_child_name {
  width: 200px;
}
.wrap_child_num {
  float: right;
  width: 60px;
  color: #8497ab;
  font-size: 16px;
  text-align: end;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.right_cont_box {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 15px;
  padding-top: 10px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.search_rsult_txttwo {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  font-size: 14px;
  color: #8497ab;
  gap: 30px;
}
.search_rsult_txttwo span {
  line-height: 40px;
}

.search_rsult_txttwo .btn_export {
  border-radius: 10px;
  font-size: 16px !important;
}
.el-button {
  min-width: 120px;
  padding: 12px 20px;
  height: 40px;
  margin-left: 0;
}
.btnBox {
  display: flex;
  justify-content: end;
  align-items: center;
  flex-grow: 1;
  gap: 20px;
}
.removeBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.loading_box {
  width: 286px;
  height: 286px;
  overflow: hidden;
  position: relative;
  margin-top: 30px;
  margin-bottom: 10px;
  background-image: url("../../../../src/assets/images/loadingOut_bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading_bg {
  margin: 0 auto;
  width: 192px;
  height: 192px;
  background-image: url("../../../../src/assets/images/loadingCon_bg.png");
  background-size: cover;
  background-position: center;
  animation: spin 3s linear infinite;
}
.loading_num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 40px;
  color: #ffffff;
  line-height: 80px;
  text-align: center;
}
.el-collapse {
  border: none !important;
}
/deep/ .el-collapse-item__wrap {
  border-bottom: 1px solid #eeeeee;
}
.blockcell {
  display: block;
}
.blockcell /deep/ .cell {
  border: none !important;
}
.scrollbar_right {
  padding: 0 !important;
}

.CompanyCompany {
  padding: 20px;
}
.fiter_ic {
  display: inline-block;
  transition: transform 0.5s ease;
  cursor: pointer;
  transform: rotate(92deg);
  color: #1290c9;
  font-size: 12px;
}
.is-active .fiter_ic {
  transform: rotate(-90deg);
}
.filter_first_box {
  border-top: 1px solid #f5f5f5;
  margin-bottom: -1px;
}
.filter_first_item {
  position: relative;
  overflow: unset !important;
}
.filter_first_item /deep/ .el-checkbox__input.is-checked + .el-checkbox__label,
.filter_first_item /deep/ .el-checkbox.is-checked .check_label {
  color: black;
}
.filter_first_item /deep/ .el-collapse-item__header {
  padding-left: 0;
}
.filter_first_item /deep/ .el-collapse-item__arrow {
  display: none;
}
.filter_first_item /deep/ .el-collapse-item__content {
  padding: 0;
}
.left_menu_filter,
.left_menu_title {
  width: calc(100% - 80px);
  font-size: 18px;
  font-family: "Arial Bold";
}
.left_menu_title {
  padding-bottom: 10px;
}
.left_menu_title {
  color: #1a2332;
}
.left_menu_filter {
  color: #1290c9;
}
.clear_all {
  top: unset;
  bottom: 8px;
}
.filter_first_checkbox {
  position: absolute;
  width: 100%;
  top: 0x;
  left: 0px;
  font-size: 16px;
  padding: 20px;
  color: #1a2332;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 99999;
  text-align: center;
}
.filter_first_checkbox /deep/ .el-checkbox {
  display: flex;
  align-items: center;
  margin-right: 0;
  justify-content: flex-start;
}
.checkAll {
  margin-bottom: 20px;
}
.filter_first_checkbox /deep/ .el-checkbox .el-checkbox__label {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  gap: 10px;
}
.filter_first_checkbox /deep/ .el-checkbox-group {
  margin-bottom: 20px;
}
.filter_first_checkbox
  /deep/
  .el-checkbox:first
  .el-checkbox__label
  .el-checkbox-group
  .check_label {
  font-size: 16px;
}
.filter_first_btn {
  width: 200px;
  color: #ffffff;
  background-color: #1290c9;
}
.filter_first_checkbox /deep/ .ellipsis {
  font-size: 16px;
}

@media (max-width: 1920px) {
  .cas_loc .el-input__inner {
    height: 30px !important;
  }
  .cas_panel .cas_input {
    font-size: 14px;
    height: 30px;
  }
  .udb507 {
    width: calc(100% - 255px);
  }
  .clear_all {
    font-size: 14px;
    top: unset;
    bottom: 5px;
  }
  .search_rsult_txttwo {
    font-size: 12px;
  }
  .search_rsult_txttwo span {
    line-height: 32px;
  }
  .search_rsult_txttwo .btn_export {
    border-radius: 8px;
    font-size: 16px !important;
  }
  .el-button {
    min-width: 100px;
    padding: 8px 16px;
    height: 32px;
  }
  .table_box /deep/ th.el-table__cell {
    height: 44px !important;
    padding: 0 !important;
  }
  .table_box /deep/ th.el-table__cell > .cell {
    font-size: 16px !important;
    line-height: 20px;
  }
  .table_box /deep/ td.el-table__cell:not(.blockcell) > .cell {
    font-size: 16px;
    line-height: 20px;
  }
  .wrap_child_num {
    font-size: 14px;
  }
  .CompanyCompany {
    padding: 15px;
  }
  .left_menu_filter,
  .left_menu_title {
    font-size: 16px;
  }
  .left_menu_title {
    padding-bottom: 7px;
  }
  .flilterClass {
    height: 30px;
    font-size: 14px;
    border-radius: 7px;
  }
  .filter_first_checkbox {
    padding: 15px;
  }
  .filter_first_btn {
    width: 150px;
  }
  .checkAll {
    margin-bottom: 16px;
  }
  .filter_first_checkbox /deep/ .el-checkbox-group {
    margin-bottom: 16px;
  }
  .filter_first_checkbox
    /deep/
    .el-checkbox
    .el-checkbox__label
    .el-checkbox-group
    .check_label {
    font-size: 14px;
  }
  .filter_first_checkbox /deep/ .ellipsis {
    font-size: 14px;
  }
}
@media screen and (max-width: 1439px) {
  .udb507 {
    width: calc(100% - 225px);
  }
  .clear_all {
    font-size: 12px;
    top: unset;
    bottom: 5px;
  }
  .search_rsult_txttwo span {
    line-height: 28px;
  }
  .search_rsult_txttwo .btn_export {
    border-radius: 6px;
    font-size: 12px !important;
  }
  .el-button {
    padding: 7px 14px;
    height: 28px;
  }
  .table_box /deep/ th.el-table__cell {
    height: 36px !important;
    padding: 0 !important;
  }
  .CompanyCompany {
    padding: 12px;
  }
  .filter_first_checkbox {
    padding: 12px;
    font-size: 14px;
    top: 30px;
  }
  .filter_first_btn {
    width: 120px;
  }
}
</style>
